import { cn } from '@core/utils/cn';

interface SpinnerProps {
  readonly size?: number;
  readonly className?: string;
  readonly label?: string;
}

/** Accessible loading spinner using currentColor. */
export function Spinner({ size = 20, className, label }: SpinnerProps): React.JSX.Element {
  return (
    <span role="status" aria-live="polite" className="inline-flex items-center">
      <svg
        className={cn('animate-spin', className)}
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        aria-hidden="true"
      >
        <circle cx="12" cy="12" r="9" stroke="currentColor" strokeOpacity="0.25" strokeWidth="3" />
        <path d="M21 12a9 9 0 0 0-9-9" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
      </svg>
      {label ? <span className="sr-only">{label}</span> : null}
    </span>
  );
}
